import { render } from "./SaleChart.vue?vue&type=template&id=9dfe1976&scoped=true"
import script from "./SaleChart.vue?vue&type=script&lang=js"
export * from "./SaleChart.vue?vue&type=script&lang=js"

import "./SaleChart.vue?vue&type=style&index=0&id=9dfe1976&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9dfe1976"]])

export default __exports__